var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.672 3.88621L10.4845 0.071666C10.2543 -0.0238652 9.99562 -0.0239121 9.76552 0.071666L0.578016 3.88621C0.228094 4.03153 0 4.37315 0 4.75204V9.38915C0 15.7741 3.85917 21.5176 9.77072 23.9305C9.99778 24.0232 10.2522 24.0232 10.4793 23.9305C16.3907 21.5176 20.25 15.7742 20.25 9.38915V4.75204C20.25 4.37315 20.022 4.03153 19.672 3.88621ZM18.375 9.38915C18.375 14.817 15.1875 19.8138 10.125 22.0442C5.19778 19.8734 1.875 14.9641 1.875 9.38915V5.37792L10.125 1.95257L18.375 5.37792V9.38915ZM9.08878 12.5492L13.1183 8.51967C13.4844 8.15357 14.078 8.15353 14.4442 8.51967C14.8103 8.88581 14.8102 9.47939 14.4441 9.84548L9.75169 14.5379C9.3855 14.9041 8.79192 14.9039 8.42587 14.5379L5.80584 11.9179C5.4397 11.5517 5.4397 10.9582 5.80584 10.5921C6.17198 10.226 6.76556 10.2259 7.13166 10.5921L9.08878 12.5492Z",
    fill: "var(--fill-0, #4B4B4B)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecure);
export default __webpack_public_path__ + "static/media/icon-secure.63270c9c2e6f06a339c9bea4f4ad58be.svg";
export { ForwardRef as ReactComponent };